import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Input, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const PasswordFormInputControl = ({
    onChange,
    disabled,
    placeholder,
    length,
    max,
    isCapital = false,
}) => {
    const handleChange = useCallback((e) => {
        let inputValue = e.target.value;
        if (isCapital) {
            inputValue = inputValue.toUpperCase();
        }
        onChange?.(inputValue);
    }, [isCapital, onChange]);

    const handleBlur = useCallback((e) => {
        onChange?.(e.target.value.trim());
    }, [onChange]);
    return (
        <div className="password-info password-input ">
            <div className="flex items-center !mb-0.5 tooltip-password absolute top-[-27px]">
                <div className="password-tooltip">
                    <Tooltip
                        title={
                            <div className="!text-start">
                                <p>Your password must contain:</p>
                                <ul className="ms-2 !text-primaryColor text-xs">
                                    <li><span className="icon tick-icon"></span>At least 8 characters</li>
                                    <li><span className="icon tick-icon"></span>At least one lowercase (a-z).</li>
                                    <li><span className="icon tick-icon"></span>At least one uppercase (A-Z).</li>
                                    <li><span className="icon tick-icon"></span>At least one number (0-9).</li>
                                    <li><span className="icon tick-icon"></span>At least one special symbol (e.g., !, @, #, $).</li>
                                </ul>
                            </div>
                        }
                        className={`align-middle ml-2`}
                    >
                        <InfoCircleOutlined />
                    </Tooltip>
                </div>
            </div>
            <div className="">
                <Input.Password
                    placeholder={placeholder}
                    disabled={disabled}
                    maxLength={length}
                    className="w-full appearance-none custom-password !pr-9"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    max={max}
                    autoComplete="off"
                />
            </div>
        </div>
    );
};
PasswordFormInputControl.propTypes = {
    type: PropTypes.oneOf(["text", "password"]),
    placeholder: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    length: PropTypes.number,
    max: PropTypes.instanceOf(Date),
    isCapital: PropTypes.bool,
};

export default PasswordFormInputControl;
